import { generateCancellationPenaltyFormattedText } from "./generateCancellationPenaltyFormattedText";
import { orderByDuration } from "./orderByDuration";
import { CancellationPenalty, CancellationPenaltyCalculationType, Price } from "./types";

export const formatCancellationPenalties = <T extends CancellationPenalty = CancellationPenalty>(
    cancellationPenalties: T[],
    languageCode = "en-GB",
    totalPrice?: Pick<Price, "gross" | "currency">,
    calculationType?: CancellationPenaltyCalculationType
): Array<
    T & {
        formattedText: string;
        ordinalPosition: number;
    }
> => {
    // TODO: TC 19/12/2022 this should be added back in once we trust our data
    // const { isValid, errors } = validateCancellationPolicy(cancellationPenalties);
    // if (!isValid) {
    //     const errorMessage = errors.join(",");
    //     throw new Error(errorMessage);
    // }

    const cancellationPenaltiesOrdered = orderByDuration(cancellationPenalties, "desc");
    return cancellationPenaltiesOrdered.map((cancellationPenalty, idx) => ({
        ...cancellationPenalty,
        formattedText: generateCancellationPenaltyFormattedText({
            languageCode,
            totalPrice,
            formattedPenaltyIndex: idx,
            cancellationPenaltyList: cancellationPenaltiesOrdered,
            calculationType,
        }),
        ordinalPosition: idx,
    }));
};
